function ContactController(){
	this.glob		= "/contact**";
};
ContactController.inheritsFrom( StandardController );
ContactController.prototype.on = function(){
	this.contactForm = new ContactForm({
		submissionUrl: this.submissionUrl
	});
};
ContactController.prototype.off = function(){
	this.contactForm.destroy();
};